module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/check_here-16c0fa273f583be08d895d44b51e685a.svg";